import * as Yup from 'yup';

const FundraisingProductValidator = () => Yup.object().shape({
  all_products_visible: Yup.boolean(),
  show_in_dropdown: Yup.boolean(),
  fixed_price_as_checkbox: Yup.boolean(),
  fixed_price_allow_quantity: Yup.boolean(),
  products: Yup.array()
    .of(
      Yup.mixed().test(
        'is-number-or-string',
        'Each item must be a number or a string',
        (value) => typeof value === 'number' || typeof value === 'string',
      ),
    )
    .min(1, 'At least one item is required')
    .required(),
  product_suggested_id: Yup.number()
    .transform((value, originalValue) => {
      if (typeof originalValue === 'string' && originalValue.trim() !== '') {
        const parsed = Number(originalValue);
        return Number.isNaN(parsed) ? originalValue : parsed;
      }
      return value;
    })
    .typeError('Product must be a number')
    .integer('Product must be an integer')
    .moreThan(0, 'Product must be greater than 0')
    .when('show_suggested', {
      is: true,
      then: (schema) => schema.required('Product is required when "Ask for fee" is true'),
      otherwise: (schema) => schema.notRequired(),
    }),
  product_fee_id: Yup.number()
    .transform((value, originalValue) => {
      if (typeof originalValue === 'string' && originalValue.trim() !== '') {
        const parsed = Number(originalValue);
        return Number.isNaN(parsed) ? originalValue : parsed;
      }
      return value;
    })
    .typeError('Product must be a number')
    .integer('Product must be an integer')
    .moreThan(0, 'Product must be greater than 0')
    .when('ask_for_fee', {
      is: true,
      then: (schema) => schema.required('Product is required when "Ask for fee" is true'),
      otherwise: (schema) => schema.notRequired(),
    })
    .nullable(),
});

export default FundraisingProductValidator;
